import React from 'react';
import generateRewardCenterCardDataRendering from 'shared/screens/RewardCenter/utils/generateRewardCenterCardDataRendering';
import RewardCenterCardContainer from './RewardCenterCard';
import styled from 'styled-components';
import { sendRewardCenterEvent } from 'shared/screens/RewardCenter/analytics/rewardCenterlogger';
import { REWARD_CENTER_EVENT_TYPES } from 'shared/screens/RewardCenter/constants';
import { getCardTitleFontSize } from 'shared/screens/RewardCenter/utils/getCardTitleFontSize';
import { isNotStandaloneMobilePWA, isStandalonePWA } from '../../../../utils/mobileSupported';

const useMobileWebCategoryLayout = isStandalonePWA || isNotStandaloneMobilePWA;
const mobileWebCategoryTitleBase = window.innerHeight <= 575 ? 0.96 : 1.06;

const RewardCenterCategories = ({
  object,
  rewardCenterAssets,
  setFilterData,
  setShowCategories,
  setCategorySelected,
  RewardsImageBaseURL,
}) => {
  const { Frame } = generateRewardCenterCardDataRendering(object, rewardCenterAssets);
  const { categoryId, categoryName, categoryDescription, categoryImage } = object;
  const categoryImageSrc = categoryImage && RewardsImageBaseURL ? `${RewardsImageBaseURL}${categoryImage}` : null;

  const handleClick = () => {
    setFilterData(categoryId);
    setCategorySelected(categoryId);
    setShowCategories(false);
    sendRewardCenterEvent(REWARD_CENTER_EVENT_TYPES.OPEN_REWARD_CENTER_CATEGORY, { category: object });
  };

  return (
    <RewardCenterCardContainer handleClick={handleClick} Frame={Frame}>
      <CardContent>
        {categoryImageSrc && <CardImage src={categoryImageSrc} />}
        <DescriptionWrapper>
          <Title titleLength={(categoryName || '').length}>{categoryName}</Title>
          <Subtitle subtitleLength={(categoryDescription || '').length}>{categoryDescription}</Subtitle>
        </DescriptionWrapper>
      </CardContent>
    </RewardCenterCardContainer>
  );
};

export default RewardCenterCategories;

const CardContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #ac7601;
  border-radius: 10%;
`;

const CardImage = styled.img`
  width: 100%;
  object-fit: contain;
  position: relative;
  border-top-left-radius: 10%;
  border-top-right-radius: 10%;
  height: 75%;
`;

const DescriptionWrapper = styled.div`
  margin-bottom: ${useMobileWebCategoryLayout ? '0.5rem' : '1rem'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
  position: relative;
  flex: 4;
  padding: 0 0.25rem;

  @media only screen and (max-height: 650px) {
    margin-bottom: 0;
  }
`;

const Title = styled.p`
  font-size: ${({ titleLength }) =>
    getCardTitleFontSize(titleLength, useMobileWebCategoryLayout ? mobileWebCategoryTitleBase : 1)};
  line-height: ${({ titleLength }) => (titleLength > 26 ? 1.02 : 1.08)};
  text-transform: uppercase;
  color: #fff;
  text-align: center;
  font-weight: 700;
  margin-bottom: 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media only screen and (min-height: 660px) {
    font-size: ${({ titleLength }) => getCardTitleFontSize(titleLength, 1.4)};
  }
  @media only screen and (min-height: 900px) {
    margin-bottom: 1rem;
    font-size: ${({ titleLength }) => getCardTitleFontSize(titleLength, 1.5)};
  }
  @media only screen and (min-height: 1000px) {
    font-size: ${({ titleLength }) => getCardTitleFontSize(titleLength, 1.8)};
  }
`;

const Subtitle = styled.p`
  font-size: ${({ subtitleLength }) => getCardTitleFontSize(subtitleLength, 0.8)};
  line-height: ${useMobileWebCategoryLayout ? 1.4 : 1.1};
  color: #fff;
  text-align: center;
  font-weight: 600;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: ${useMobileWebCategoryLayout ? 1 : 2};
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media only screen and (min-height: 660px) {
    font-size: ${({ subtitleLength }) => getCardTitleFontSize(subtitleLength, 1)};
    margin-bottom: 0;
  }
  @media only screen and (min-height: 900px) {
    font-size: ${({ subtitleLength }) => getCardTitleFontSize(subtitleLength, 1.2)};
  }
`;
